const roles = {
  ADMIN: 'admin',
  ADMIN_ID: 1,
  STATION_SHIFT_SUPERVISOR: 'stationShiftSupervisor',
  STATION_SHIFT_SUPERVISOR_ID: 2,
  USER: 'user',
  USER_ID: 6,
  ANALYST: 'analyst',
  ANALYST_ID: 7,
  STATION_ANALYST: 'stationAnalyst',
  STATION_ANALYST_ID: 8,
  STATION_DIRECTOR: 'stationDirector',
  STATION_DIRECTOR_ID: 9,
} as const

export default roles
